import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledHeaderWrapper = styled(FlexRow)`
    align-items: center;
    padding: 18px 24px;
    column-gap: 32px;
`;

export const StyledCompanyInfoWrapper = styled(FlexRow)`
    align-items: center;
    padding: 8px 12px;
`;

export const StyledIconButton = styled(IconButton)`
    align-self: center;
    margin-left: auto;
`;
